
import {ProfileLotModel } from '../models/ProfileLotModel.js';
import {ProfileLotView } from '../views/ProfileLotView.js';

export class ProfileLotController {
    constructor() {

        this.model = new ProfileLotModel();
        this.view = new ProfileLotView();

        this.model.subscribe(state => this.view.render(state));
    }
}